const persianMap = {
  "۰": "0",
  "۱": "1",
  "۲": "2",
  "۳": "3",
  "۴": "4",
  "۵": "5",
  "۶": "6",
  "۷": "7",
  "۸": "8",
  "۹": "9",
};

const arabicMap = {
  "٠": "0",
  "١": "1",
  "٢": "2",
  "٣": "3",
  "٤": "4",
  "٥": "5",
  "٦": "6",
  "٧": "7",
  "٨": "8",
  "٩": "9",
};

export default function convertToEnglishNumbers(value) {
  return value
    .toString()
    .replace(/[۰-۹]/g, w => persianMap[w])
    .replace(/[٠-٩]/g, w => arabicMap[w]);
}
